<template>
    <div class="traffic-light-item">
      <div class="value">
        <slot />
      </div>
      <div class="sub">
        {{ secondary }}
      </div>
    </div>
</template>

<script>

export default {
  props: {
    secondary: {
      type: [String,Number],
      default: null,
    },
  },
  computed: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/theme.scss";

  .traffic-light-item{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    
    & .value{
      font-size: large;
      font-weight: bold;
      color: $color-text-bold;
      // text-shadow: 0px 1px 8px rgba(0,0,0,0.3);
    }

    & .sub{
      margin-top: 5px;
      min-height: 15px;
      line-height: 15px;
      font-weight: bold;
      text-align: center;
      color: $color-text-light;
    }
  }

</style>
